import { IonContent } from "@ionic/react";
import HeaderComponent from "../components/HeaderComponent";

const Graphs: React.FC = () => {
  return (
    <IonContent fullscreen>
      <HeaderComponent title={"Graphs"} />
      <h2>Graphs page</h2>
    </IonContent>
  );
};

export default Graphs;
